/** Visible choghadiya result copy per page language (/choghadiya vs /hi/choghadiya). */
export type ChoghadiyaLanguage = "en" | "hi";

export const CHOGHADIYA_RESULT_COPY = {
  en: {
    sunrise: "Sunrise",
    sunset: "Sunset",
    day: "Day",
    vaar: "Vaar",
    active: "Active Choghadiya:",
    dayTitle: "Day Choghadiya",
    dayTitleAlt: "दिन का चौघड़िया",
    nightTitle: "Night Choghadiya",
    nightTitleAlt: "रात का चौघड़िया",
    now: "Now",
    quality: { best: "Best", good: "Good", neutral: "Neutral", bad: "Bad" } as Record<
      string,
      string
    >,
    inauspicious: "Inauspicious Periods",
    inauspiciousAlt: "वार वेला · काल वेला · काल रात्रि",
    inauspiciousBody:
      "Avoid starting new work during these periods. Tradition considers them unfavourable for auspicious activities.",
    vaarVela: "Vaar Vela",
    kaalVela: "Kaal Vela",
    kaalRatri: "Kaal Ratri",
    and: "and",
    legend: ["Best (Amrit)", "Good (Shubh, Labh)", "Neutral (Char)", "Avoid (Rog, Kaal, Udveg)"],
    legendColumns: ["Choghadiya", "Quality", "Recommended Activities"],
  },
  hi: {
    sunrise: "सूर्योदय",
    sunset: "सूर्यास्त",
    day: "वार",
    vaar: "Vaar",
    active: "अभी का चौघड़िया:",
    dayTitle: "दिन का चौघड़िया",
    dayTitleAlt: "Day Choghadiya",
    nightTitle: "रात का चौघड़िया",
    nightTitleAlt: "Night Choghadiya",
    now: "अभी",
    quality: { best: "उत्तम", good: "शुभ", neutral: "सामान्य", bad: "अशुभ" } as Record<
      string,
      string
    >,
    inauspicious: "अशुभ समय",
    inauspiciousAlt: "Vaar Vela · Kaal Vela · Kaal Ratri",
    inauspiciousBody:
      "इन समयों में नया काम शुरू करने से बचें। परंपरा इन्हें शुभ कार्यों के लिए प्रतिकूल मानती है।",
    vaarVela: "वार वेला",
    kaalVela: "काल वेला",
    kaalRatri: "काल रात्रि",
    and: "और",
    legend: ["उत्तम (अमृत)", "शुभ (शुभ, लाभ)", "सामान्य (चल)", "बचें (रोग, काल, उद्वेग)"],
    legendColumns: ["चौघड़िया", "गुण", "किन कामों के लिए"],
  },
} as const;

export const CHOGHADIYA_MEANINGS = [
  {
    name: "Amrit (अमृत)",
    quality: "best",
    meaning: { en: "Nectar / Highest Good", hi: "अमृत / सर्वोत्तम" },
    bestFor: {
      en: "All auspicious tasks, holy puja, travel",
      hi: "सभी शुभ कार्य, पूजा, यात्रा",
    },
  },
  {
    name: "Shubh (शुभ)",
    quality: "good",
    meaning: { en: "Auspicious / Sacred", hi: "शुभ / पवित्र" },
    bestFor: {
      en: "Ceremonies, marriage talks, purchasing property, study",
      hi: "संस्कार, विवाह की बात, संपत्ति खरीद, पढ़ाई",
    },
  },
  {
    name: "Labh (लाभ)",
    quality: "good",
    meaning: { en: "Profit / Gain", hi: "लाभ / उन्नति" },
    bestFor: {
      en: "New business ventures, opening accounts, trade",
      hi: "नया व्यापार, खाता खोलना, लेन-देन",
    },
  },
  {
    name: "Char (चल)",
    quality: "neutral",
    meaning: { en: "Movement / Dynamic", hi: "गति / चलायमान" },
    bestFor: {
      en: "Journeys, vehicle driving, commuting, short-term tasks",
      hi: "यात्रा, वाहन चलाना, आना-जाना, छोटे काम",
    },
  },
  {
    name: "Rog (रोग)",
    quality: "bad",
    meaning: { en: "Affliction / Disease", hi: "रोग / कष्ट" },
    bestFor: {
      en: "Inauspicious — avoid starting major projects",
      hi: "अशुभ — बड़े काम शुरू न करें",
    },
  },
  {
    name: "Kaal (काल)",
    quality: "bad",
    meaning: { en: "Loss / Inauspicious", hi: "हानि / अशुभ" },
    bestFor: {
      en: "Inauspicious — strictly avoid financial risks or new journeys",
      hi: "अशुभ — आर्थिक जोखिम और नई यात्रा से बचें",
    },
  },
  {
    name: "Udveg (उद्वेग)",
    quality: "bad",
    meaning: { en: "Anxiety / Stress", hi: "उद्वेग / तनाव" },
    bestFor: {
      en: "Inauspicious — avoid official disputes or government work",
      hi: "अशुभ — सरकारी काम और विवाद से बचें",
    },
  },
] as const;
